import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function PrivateRoute({ children, perfil }) {
  const { user, loading, isAdmin, isFenix } = useAuth();

  if (loading) return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <div className="spinner-border" style={{ color: 'var(--main-color)' }} />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;
  if (perfil === 'admin' && !isAdmin) return <Navigate to="/dashboard" replace />;
  if (perfil === 'fenix' && !isFenix) return <Navigate to="/dashboard" replace />;

  return children;
}
